import React, { Component } from 'react';
import moment from "moment-timezone";
import {map, sortBy, isEmpty} from 'lodash';
import Loader from "../../../../Common/Component/Loader";
// import pin from '../../../../../Assets/images/pin.png';
import EmailRemainder from "../Common/EmailRemainder";
import PrivateNotes from "../Common/PrivateNotes";
import noActiveService from '../../../../../../src/Assets/images/no-active-service.svg';
import axios from "../../../../../Lib/axios";
import { getLastThreePayment } from '../../../../../Action';
import { formatToCurrency } from "../../../../../Tools/formatToCurrency";

import {message, Pagination} from "antd";

// mapping STATUS for hardcoded
const STATUS = {
  draft: 'Draft',
  open: 'Open',
  'open-emailed': 'Open',
  'open-printed': 'Open',
  'overdue': 'Overdue',
  paid: 'Paid',
  void: 'Void',
  "CC Auto": "CC Auto"
};

// mapping frequency for hardcoded
// const FREQUENCY_MAPPING = {
//   weekly: 'Weekly',
//   bi_monthly: 'Every Other Week',
//   once: 'Just Once',
//   twice_weekly: 'Twice Weekly',
//   monthly: 'Monthly'
// };

// marker pin
// const MarkerPin = (props) =>
//   <div className="marker_wrapper d-flex align-items-center">
//     <img style={{ 'width': '15px' }} src={pin} alt="" className="pin" />
//     <div className="pulse"><span style={{'color': 'red', 'whiteSpace': 'nowrap','fontSize': '9px', 'display': 'block','lineHeight': '14px'}}>{props?.address || ''}</span></div>
//   </div>;

class AccountOverview extends Component {
  state = {
    customer: {},
    loader: false,
    serviceOrder: [],
    emailReminderModal: false,
    authorizedUser: {},
    cardList: {},
    cardDetail: {},
    invoiceList: {},
    invoiceSummary: {},
    complaintCount: 0,
    messageList: {},
    lastThreePaymentList:{},
    LastThreeCreditMemo:[],
    last_th_cr_memo:{}
  }

  componentDidMount = () => {
    const {getServiceOrder, getAuthorizedUserList, customerId, getCardList, getInvoiceList, getInvoiceSummary, getAllMessages, getCustomerDetail,getLastThreePayment, getServiceOrderEnquiry} = this.props;
    this.props.onClearFromOverview();
    if (customerId) {
      this.setState({loader: true});
      this.props.lastThreeCreditMemo({user__uuid:customerId,limit:3})
      getAuthorizedUserList && getAuthorizedUserList({user__uuid: customerId}) // get authorized user list
      getCardList && getCardList({ user__uuid: customerId }) // get card list
      getInvoiceList && getInvoiceList({user__uuid: customerId}) // get invoice list
      getLastThreePayment && getLastThreePayment({user__uuid: customerId}) // get Last Three Payment
      getInvoiceSummary && getInvoiceSummary({user__uuid: customerId}) // get invoice summary
      getAllMessages && getAllMessages({reason: 'complaint', user__uuid: customerId, created_at__lte: moment().format('YYYY-MM-DD HH:mm:ss'), created_at__gte: moment().subtract((moment().daysInMonth() - 1), 'days').format('YYYY-MM-DD HH:mm:ss')}) // get list of complaints

      Promise.allSettled([
        this.setState({loader: true}),
        getCustomerDetail(customerId),
        getServiceOrder({user__uuid: customerId, limit: 5, offset: 0, is_active: true}),
        getServiceOrderEnquiry({user__uuid: customerId, limit: 5, offset: 0})
      ]).then(result => {
        const { serviceOrder, serviceOrderEnquiry, customerList } = this.props;

        // get service order
        if (Object.keys(serviceOrder?.data).length > 0 ) {
          this.setState({serviceOrder: serviceOrder?.data?.results, totalServiceOrders: serviceOrder?.data?.count});
        }

        // get service order enquiry
        if (serviceOrderEnquiry && serviceOrderEnquiry?.enquiryList && serviceOrderEnquiry?.enquiryList?.results?.length > 0) {
          this.setState({serviceOrder: serviceOrderEnquiry?.enquiryList?.results, totalServiceOrders: serviceOrderEnquiry?.enquiryList?.count});
        }

        // get customer detail
        if (Object.keys(customerList?.customer).length > 0) {
          this.setState({ customer: customerList?.customer });
        }
        this.setState({loader: false});
      });

      axios.get(`/credit-memo/`, {params: {user__uuid: customerId, limit: 3}}).then((response) => {
        this.setState({
          last_th_cr_memo:response.data
        })
      }).catch(error => {
        message.error(`Error occurred while calculating the Tax.`, 30);
      });
    }
  }

  fetchServiceOrders = (serviceOrderPage = 1) => {
    const { getServiceOrder, customerId } = this.props;
    this.setState({serviceOrderPage, loader: true});
    Promise.allSettled([
      getServiceOrder({ user__uuid: customerId, is_active: true, limit: 5, offset: (serviceOrderPage - 1) * 5})
    ]).then(result => {
      const { serviceOrder } = this.props;
      // get service order
      if (Object.keys(serviceOrder?.data).length > 0 ) {
        this.setState({serviceOrder: serviceOrder?.data?.results, totalServiceOrders: serviceOrder?.data?.count});
      }
    });
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // message.destroy()
    const {authorizedUser, cardDetail, cardList, invoiceList, invoiceSummary,lastThreePaymentList,LastThreeCreditMemo} = this.state;

    // Get authorized user list
    if (Object.keys(nextProps?.authorizedUser?.userList).length > 0 && JSON.stringify(nextProps?.authorizedUser?.userList) !== JSON.stringify(authorizedUser)) {
      this.setState({authorizedUser: nextProps?.authorizedUser?.userList});
    }

    // get card list
    if (Object.keys(nextProps?.cardList?.data).length > 0
      && JSON.stringify(nextProps?.cardList?.data) !== JSON.stringify(cardList)) {
      this.setState({ cardList: nextProps?.cardList?.data });
    }

    // send email for cc expiry
    if (Object.keys(nextProps?.emailReminder?.sendEmail).length > 0) {
      const idx = cardList?.results?.findIndex(obj => obj.uuid === cardDetail.uuid);
      if (idx > -1) {
        Object.assign(cardList?.results?.[idx], {email_reminder: [...cardList?.results?.[idx]?.email_reminder, nextProps?.emailReminder?.sendEmail]});
        this.setState({cardList})
      }
    }

    // get invoice list
    if (Object.keys(nextProps?.Invoice?.list).length > 0
      && JSON.stringify(nextProps?.Invoice?.list) !== JSON.stringify(invoiceList)) {
      this.setState({invoiceList: nextProps?.Invoice?.list})
    }

    // get last three payment
    if (Object.keys(nextProps?.LastThreePayment?.data).length > 0
      && JSON.stringify(nextProps?.LastThreePayment?.data) !== JSON.stringify(lastThreePaymentList)) {
      this.setState({lastThreePaymentList: nextProps?.LastThreePayment?.data})
    }

    // get last three payment
    // if (Object.keys(nextProps?.LastThreeCreditMemo).length > 0
    //   && JSON.stringify(nextProps?.LastThreeCreditMemo) !== JSON.stringify(LastThreeCreditMemo)) {
    //   this.setState({LastThreeCreditMemo: nextProps?.LastThreeCreditMemo})
    // }

    // invoice summary
    if (Object.keys(nextProps?.Invoice?.invoiceSummary).length > 0
      && JSON.stringify(nextProps?.Invoice?.invoiceSummary) !== JSON.stringify(invoiceSummary)) {
      this.setState({invoiceSummary: nextProps?.Invoice?.invoiceSummary})
    }

    //get complaint message count
    if (Object.keys(nextProps?.AllMessages?.data).length > 0 &&
      JSON.stringify(nextProps?.AllMessages?.data) !== JSON.stringify(this.state?.messageList)) {
      this.setState({
        messageList: nextProps?.AllMessages?.data,
        complaintCount: nextProps?.AllMessages?.data?.results?.length,
        loader: false
      })
    }
    
    // get customer detail
    // if (Object.keys(nextProps?.Invoice?.suspendAccount).length > 0
    //   && JSON.stringify(nextProps?.Invoice?.suspendAccount) !== JSON.stringify(this.props.Invoice?.suspendAccount)) {
    //   this.setState({ loader: false });
    //   this.props.getCustomerDetail(this.props.customerId)
    // }

    this.setState({loader: false})
  }

  // convert date time from utc to local time
  UTCToLocal = (date) => {
    let stillUtc = moment.utc(date).toDate();
    return moment(stillUtc).local();
  }

  // convert date time from local to utc
  localToUTC = (date) => {
    return moment.utc(date)
  }

  // format phone number
  formatPhoneNumber = (phone) => {
    phone = phone?.replace(/\D/g, '');
    return phone?.substr(0, 3) + ' ' + phone?.substr(3, 3) + ' ' + phone?.substr(6);
  }

  // on text change
  onTextChange = (e) => {
    this.setState({[e.target.name]: e.target.value});
  };

  //toggle email remainder modal
  toggleEmailRemainder = (value) => {
    this.setState({emailReminderModal: value})
  };
  // convert date time from utc to local time
  UTCToLocal = (date) => {
    let stillUtc = moment.utc(date).toDate();
    return moment(stillUtc).local();
  }
  // render primary info
  renderPrimaryInfo = () => {
    const {customer, authorizedUser} = this.state;
    const name = customer?.first_name ? `${customer?.first_name} ${customer?.last_name}` : '';
    let phone_numbers = '', primaryEmail = '';
    if (!isEmpty(customer?.phone_numbers)) {
      for (let i = 0; i < customer?.phone_numbers?.length; i++) {
        const item = customer?.phone_numbers?.[i];
        if (item?.primary) {
          phone_numbers = item?.phone;
          break;
        }
      }
    }

    !isEmpty(customer?.emailaddress_set) && map(customer?.emailaddress_set, (item) => {
      primaryEmail = item?.primary && item?.email;
    });

    let authorizedUserName = ''
    map(sortBy(authorizedUser?.results, 'created_by'), (item, index) => authorizedUserName+= `${index !== 0 ? ', ' : ''}${item?.user_name}`)
    
    return (
      <div className="card">
        <div className="card-title flex">
          <h5>Primary Information</h5>
        </div>
        <div className="card-body">
          <div className="flex flex-start mb-10">
            <div className="label">
              <b>Primary User:</b>
              <span>Authorized Users: </span>
            </div>
            <div className="value">
              <b>{name}</b>
              <span>{authorizedUserName}</span>
            </div>
          </div>
          <div className="mb-10"><b>{!isEmpty(customer?.phone_numbers) ? phone_numbers ? `+1 ${this.formatPhoneNumber(phone_numbers)} (Primary)` : `+1 ${this.formatPhoneNumber(customer?.phone_numbers?.[0]?.phone)}` : ''}</b></div>
          {!customer?.is_dummy_email && customer?.email && !customer.email.includes('doody.com') &&
            <div><b>{`${primaryEmail ? primaryEmail : customer?.email} (Primary)`}</b> </div>
          }          
        </div>
      </div>
    )
  };

  renderActiveServices = () => {
    console.log("renderActiveServices");
    let items = this.state.serviceOrder.filter((item) => item.is_active) || [];
    if(this.state.loader) {
      return <div className="card">
        <div className="card-title flex">
          <h5>Active Services</h5>
          <button className="btn btn-warning view-all-btn" onClick={(e) => {e.preventDefault(); this.props.tabChange(2)}}>View All</button>
        </div>
        <div className="card-body">

        </div>
      </div>
    }

    return (
      <div className="card">
        <div className="card-title flex">
          <h5> {this?.props?.customer?.status === "pending" ? "Inquired Services" : "Active Services"} </h5>
          <button className="btn btn-warning view-all-btn" onClick={(e) => {e.preventDefault(); this.props.tabChange(2)}}>View All</button>
        </div>
        <div className="card-body">
          {
            items.length === 0 && <div className="no-service text-center">
              <img className="mr-5" src={noActiveService} alt=""/>
              <h5>No Active Services</h5>
              <p>Service orders will appear here when active.</p>
            </div>
          }
          {
            items?.map((item, index) => {

              // for pre-pay message
              const expDate = moment(item?.initial_cleaning).add(6, 'month')
              const diff = moment(expDate).diff(moment(), 'days');
              const displayDiff = moment(expDate).fromNow();
              const displayText = diff < 0 ? `expired for ${displayDiff}` : `will expires in the next ${displayDiff}`;

              return <React.Fragment key={index}>
                {!isEmpty(item?.service_address) ? <div className="service-status p-0 aoa-service">
                  <div className="active_service_list color-252730">
                    <div className="subs">
                      <div className="flex justify-content-start position-relative">
                        <strong className="snum">{item?.service_order_number}</strong>
                        <span className="color-1F1F25 opacity-5 fs-12">{item?.frequency_type ? `${this.setRecurring(item?.frequency_type)}` : ''}</span>
                      </div>
                      <div className="position-relative">
                        <span className="service-arrow ">
                          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAOBAMAAADgeEClAAAAAXNSR0IB2cksfwAAAB5QTFRFAAAAdHR0b29vcHBwbm5ub29vb29vbm5ua2trbm5uzpGQqQAAAAp0Uk5TAAtOOfVlRWQ5T+9n3DQAAAAkSURBVHicYxBiAAKTACDB5gpipqAz3WEEiAuWgDNaQAokgRgAy9cGGr87WN8AAAAASUVORK5CYII=" alt="" 
                            onClick={(e) => { e.preventDefault();this.props.tabChange(2); this.props.viewServiceDetail(true, item); }} 
                          />
                        </span>
                        <h5 className={this?.props?.customer?.status === "pending" ? "sadd1 mb-4" : "sadd mb-4"}>{!isEmpty(item?.service_address) ? `${item?.service_address?.address}, ${item?.service_address?.city}, ${item?.service_address?.state} ${item?.service_address?.zip_code}` : '-'}</h5>
                        {!isEmpty(item?.service_address?.geo_location) ? <span className="altude pl-20 opacity-5 fs-11"> {`${item?.service_address?.geo_location?.latitude}, ${item?.service_address?.geo_location?.longitude}`}</span> : <></>}
                        {item?.last_increase_effective_date?
                          <div>
                            <strong class="altude pl-20 fs-11" style={{marginBottom: "auto", color: "#407977"}}>Price Increase Date: {item?.last_increase_effective_date?this.UTCToLocal(item?.last_increase_effective_date).format('MMM DD, YYYY'):"-"}</strong>
                            <strong class="altude pl-20 fs-11" style={{marginBottom: "auto", color: "#407977"}}>Price Increase: {item?.last_increase_amount?item?.last_increase_amount:"-"}  {item?.last_increase_status? item?.last_increase_status === "Completed"?"(Applied)":"(Yet to be applied)" : "-"}</strong>                        
                            </div>
                        :
                          <></>
                        }
                        {/* <hr/> */}
                      </div>
                    </div>
                  </div>
                </div> :
                  <></>
                }
                {(item?.calculated_price?.is_prepaid && diff <= 30) &&
                  <blockquote className="horiz">
                    <b>This service is on a pre-pay plan. This {displayText}.</b>
                    <p className="mb-0">This customer needs to update their pre-pay plan, or move to monthly payments.</p>
                  </blockquote>}
              </React.Fragment>
            })
          } 
          {this.state.totalServiceOrders > 5 && <center><Pagination onChange={(page) => {this.fetchServiceOrders(page)}} size="small" current={this.state.serviceOrderPage || 1} total={this.state.totalServiceOrders || 5} showTotal={false} pageSize={5}/></center>}
        </div>
      </div>
    )
  }

  // render active service
  renderActiveService = (item, index) => {
    // for pre-pay message
    const expDate = moment(item?.initial_cleaning).add(6, 'month')
    const diff = moment(expDate).diff(moment(), 'days');
    const displayDiff = moment(expDate).fromNow();
    const displayText = diff < 0 ? `expired for ${displayDiff}` : `will expires in the next ${displayDiff}`;

    return (
      <React.Fragment key={`serviceOrder${index}`}>
        <div className="card">
          <div className="card-title flex">
            <h5>Active Services</h5>
            <button className="btn btn-warning view-all-btn" onClick={(e) => {e.preventDefault(); this.props.tabChange(2)}}>View All</button>
          </div>
          <div className="card-body">
            {!isEmpty(item?.service_address) ? <div className="service-status p-0 aoa-service">
              <div className="active_service_list color-252730">
                <div className="subs">
                  <div className="flex justify-content-start position-relative">
                    <strong className="snum">{item?.service_order_number}</strong>
                    <span className="color-1F1F25 opacity-5 fs-12">{item?.frequency_type ? `${this.setRecurring(item?.frequency_type)}` : ''}</span>
                  </div>
                  <div className="position-relative">
                    <span className="service-arrow ">
                      <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAOBAMAAADgeEClAAAAAXNSR0IB2cksfwAAAB5QTFRFAAAAdHR0b29vcHBwbm5ub29vb29vbm5ua2trbm5uzpGQqQAAAAp0Uk5TAAtOOfVlRWQ5T+9n3DQAAAAkSURBVHicYxBiAAKTACDB5gpipqAz3WEEiAuWgDNaQAokgRgAy9cGGr87WN8AAAAASUVORK5CYII=" alt=""/>
                    </span>
                    <h5 className="sadd mb-4">{!isEmpty(item?.service_address) ? `${item?.service_address?.address}, ${item?.service_address?.city}, ${item?.service_address?.state} ${item?.service_address?.zip_code}` : '-'}</h5>
                    <span className="altude pl-20 opacity-5 fs-11">{!isEmpty(item?.service_address?.geo_location) ? `${item?.service_address?.geo_location?.latitude}, ${item?.service_address?.geo_location?.longitude}` : ``}</span>
                    {/* <hr/> */}
                  </div>
                </div>
              </div>
            </div> :
              <div className="no-service text-center">
                <img className="mr-5" src={noActiveService} alt=""/>
                <h5>No Active Services--</h5>
                <p>Service orders will appear here when active.</p>
              </div>
            }
          </div>
        </div>
        {(item?.calculated_price?.is_prepaid && diff <= 30) &&
        <blockquote className="horiz">
          <b>This service is on a pre-pay plan. This {displayText}.</b>
          <p className="mb-0">This customer needs to update their pre-pay plan, or move to monthly payments.</p>
        </blockquote>}
      </React.Fragment>
    )
  }

  setRecurring = (frequency) => {
    switch (frequency) {
    case 'twice_weekly':
      return 'Twice Weekly'
    case 'weekly':
      return 'Weekly'
    case 'bi_monthly':
      return 'Every Other Week'
    case 'monthly':
      return 'Monthly'
    case 'once':
      return 'One-Time'
    default:
      return ''
    }
  }

  // render invoice
  renderInvoice = () => {
    const {cardList, invoiceList, invoiceSummary, customer, lastThreePaymentList,last_th_cr_memo} = this.state;
    let lastThreePaymentListArr = [];
    let lengthLastThreePaymentList = lastThreePaymentList.length;
    var size = lengthLastThreePaymentList>3?3:lengthLastThreePaymentList;
    lastThreePaymentListArr = lengthLastThreePaymentList>0?lastThreePaymentList.slice(0, size):[];
    let invoice = [],  payments = [], overdue_days = 0
    map(invoiceList?.results, x => {
      if (x.status === 'overdue') overdue_days = moment(x.due_date).diff(moment(), 'days')
      if(x.status!=='draft'){
        invoice.push({date: x.invoice_date, amount: x.balance_due, type: x.status, uuid: x.uuid, service_order_uuid: x.service_order_uuid})
      }
    })
    map(invoiceList?.results, x => {
      if (x.status === 'paid') {
        payments.push({date: x.invoice_date, amount: x.balance_due, type: x.payment_method_type, uuid: x.uuid, service_order_uuid: x.service_order_uuid})
      }
    })

    let isCardExpired = false, cardDetail = {}, displayText = '';
    const list = cardList?.results || [];
    for (let i = 0; i < list?.length; i++) {
      const item = list[i];
      const expDate = `${item?.stripe_card_details?.exp_month}/01/${item?.stripe_card_details?.exp_year}`;
      const diff = moment(expDate).diff(moment(), 'days');
      const displayDiff = moment(expDate).fromNow();
      displayText = diff < 0 ? `expired for ${displayDiff}` : `will expire ${displayDiff}`;
      if (diff <= 60) {
        isCardExpired = true;
        cardDetail = item;
        break;
      }
    }

    return (
      <div className="card invoice-payment">
        <div className="card-title flex">
          <h5>Invoicing</h5>
          <button className="btn btn-warning" onClick={(e) => {e.preventDefault(); this.props.tabChange(4) }}>View Invoices</button>
        </div>
        <div className="card-body p-0">
          <span className="smhead">Last 3 Invoices</span>
          {invoice?.length > 0 ?
            map(invoice.slice(-3), (item, index) =>
              <a><div className={`flex scell ${item.type === 'overdue' ? 'overdue' : ''} cursor_pointer`} key={`invoice${index}`} onClick={() => {
                this.props.onInvoiceLineClick(item?.uuid, item?.service_order_uuid)
                this.props.tabChange(4)
              }}>
                <span className="sdate">{
                  item?.type === 'overdue' ?
                    <u>{moment(item?.date).format('MMMM YYYY')}</u> : moment(item?.date).format('MMMM YYYY')}</span>
                <div className="sdetail flex">
                  <span className="amt">${formatToCurrency(item?.amount)}</span>
                  <span className={`stats-color ${item.type === 'overdue' ? 'danger' : 'success'}`}><b>{STATUS[item?.type]}</b></span>
                </div>
              </div></a>
            ) : <div className="flex scell">-</div>
          }
        </div>
        <div>
          <span className="smhead">Last 3 Payments Made</span>
          {lastThreePaymentListArr?.length > 0 ?
            map(lastThreePaymentListArr, (item, index) =>
              <a><div  className="flex scell cursor_pointer" key={`invoice${index}`} onClick={() => {
                // this.props.onInvoiceLineClick(item?.uuid, item?.service_order_uuid)
                this.props.onInvoicePaymentHistoryClick(item?.invoice_uuid)
                this.props.tabChange(4)
              }}>
                <span className="sdate">{moment(item?.created_at).format('MMMM YYYY')}</span>
                <div className="sdetail flex">
                  <span className="amt">${formatToCurrency(item?.amount)}</span>
                  <span className="stats-color success"><b>{item?.payment_mode}</b></span>
                </div>
              </div></a>
            ) : <div className="flex scell">-</div>
          }
        </div>
        {/* <div>
          <span className="smhead">Last 3 Credit Memo</span>
          {last_th_cr_memo?.count > 0 ?
            map(last_th_cr_memo?.results, (item, index) =>
              <a><div  className="flex scell cursor_pointer" key={`invoice${index}`} onClick={() => {
                // this.props.onInvoiceLineClick(item?.uuid, item?.service_order_uuid)
                this.props.onCreditMemoClick(item?.uuid)
                this.props.tabChange(4)
              }}>
                <span className="sdate">{moment(item?.date_creditmemo).format('MMMM YYYY')}</span>
                <div className="sdetail flex">
                  <span className="amt">$-{(Math.round(item?.total_with_tax * 100) / 100).toFixed(2)}</span>
                  <span className={`stats-color ${item.status === 'close' ? 'danger' : 'success'}`}><b>{item?.status}</b></span>
                </div>
              </div></a>
            ) : <div className="flex scell">-</div>
          }
        </div> */}
        <div className="card-body">
          {invoiceList?.results?.length > 0 ? <div className="flex flex-start">
            <h3 className="danger mb-0">{(invoiceSummary?.overdue_invoices_amount?.total__sum) ? formatToCurrency(invoiceSummary?.overdue_invoices_amount?.total__sum) : ''}</h3>
            {customer?.suspend ? <span className="status inactive">Suspended</span> : ''}
          </div> : ''}
          {(invoiceList?.results?.length > 0 && overdue_days > 0) ? <span className="danger d-block xshead mt-10"><b>{overdue_days} days over due</b></span> : ''}
          {
            isCardExpired &&
            <blockquote className="suspend mt-10">
              <span className="danger d-block mb-10"><b>{`This customer’s credit card ${displayText}. Please contact them to update`}</b></span>
              <button
                className="btn btn-danger"
                onClick={() => {this.setState({cardDetail}); this.toggleEmailRemainder(true)}}>
                Send Reminder Email</button>
            </blockquote>
          }
        </div>
      </div>
    )
  };

  // render private notes
  renderPrivateNotes = () => {
    return <PrivateNotes
      customerId={this.props.customerId}
      getAccountNotes={this.props.getAccountNotes}
      addAccountNotes={this.props.addAccountNotes}
      accountNotes={this.props.accountNotes}
    />
  };

  //render customer metrics
  renderMetrics = () => {
    const {complaintCount, customer} = this.state;
    return (
      <div className="card cust-metric">
        <div className="card-title">
          <h5>Customer Metrics</h5>
        </div>
        <div className="card-body">
          <div className="flex">
            <span>
              <h2 className="success">{complaintCount || '0'} <sub className={"cursor_pointer"}><i className="las la-external-link-alt" onClick={() => this.props.tabChange(5)}/></sub></h2>
              Complaints in the past 30 days
            </span>
            <span>
              <h2 className="success">{`${customer?.customer_satisfaction_score ? customer?.customer_satisfaction_score : '0'}%`}</h2>
              Customer satisfaction score
            </span>
          </div>
        </div>
      </div>
    )
  };

  render() {
    const {loader, emailReminderModal, customer, cardDetail} = this.state;
    return (
      <div className="block-row">
        <div className="card-row show-lg">
          {loader && <Loader />}
          <div className="card-col">
            {this.renderPrimaryInfo()}
            {customer?.status !== "pending" && this.renderMetrics()}
            {this.renderActiveServices()}
          </div>          
          <div className="card-col">
            {this.renderPrivateNotes()}            
            {customer?.status !== "pending" && this.renderInvoice()}
          </div>
          {emailReminderModal && <EmailRemainder
            visible={emailReminderModal}
            customer={customer}
            cardDetail={cardDetail}
            handleOk={(obj) => this.props.sendEmailReminder(obj)}
            handleCancel={() => this.toggleEmailRemainder(false)}
          />}
        </div>
        <div className="card-row hide-lg">
          {loader && <Loader />}
          <div className="card-col">
            {this.renderPrimaryInfo()}
            {customer?.status !== "pending" && this.renderMetrics()}
          </div>
          <div className="card-col">
            {this.renderActiveServices()}
          </div>
          <div className="card-col">
            {this.renderPrivateNotes()}
          </div>
          <div className="card-col">
            {customer?.status !== "pending" && this.renderInvoice()}
          </div>
          {emailReminderModal && <EmailRemainder
            visible={emailReminderModal}
            customer={customer}
            cardDetail={cardDetail}
            handleOk={(obj) => this.props.sendEmailReminder(obj)}
            handleCancel={() => this.toggleEmailRemainder(false)}
          />}
        </div>
      </div>
     
    );
  }
}

export default AccountOverview;
